import __json from '../config/l10n.json';

type DataFromJson = {
	nameOrderLastFirst: readonly string[];
};

export const data: DataFromJson = __json;
